// import { ThunkDispatch, UnknownAction, combineReducers, configureStore } from '@reduxjs/toolkit'
import { combineReducers, configureStore } from '@reduxjs/toolkit'

// redux-persist: Saves parts of the Redux state to persistent storage (like localStorage).
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage
import data from './data'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import authReducer from "./authSlice"; // Here, authReducer is just the name given to the default export authSlice.reducer. 

const rootReducer = combineReducers({
    data
})

const persistedReducer = persistReducer(
    {
        key: 'root', // Key for localStorage (data saved under 'persist:root')
        storage,   // Where to save (localStorage by default)
        whitelist: ['data'] // Only persist the 'data' slice of the state,auth is not persisted unless added to the whitelist.
    },
    rootReducer
)




export const store = configureStore({
    // reducer: persistedReducer,
    reducer:{ persistedReducer,  // Contains the persisted `data` reducer
        auth: authReducer,  // i can rename this "auth" key to anything else, such as "userAuth"
    },
    // Handles async logic and state serialization checks.
    middleware: (getDefaultMiddleware) =>      
        getDefaultMiddleware({
            serializableCheck: {
                // Ignored Actions: Redux Persist uses non-serializable actions; these are excluded from checks to prevent warnings
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            }
        })
  
})

// RootState: Represents the shape of your Redux state.
export type RootState = ReturnType<typeof store.getState>

//AppDispatch: Typed dispatch for supporting asynchronous actions; Catch invalid dispatches;
// export type AppDispatch = ThunkDispatch<RootState, any, UnknownAction>
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const persistor = persistStore(store)
